"use client";

import { AppPageTitle } from "@/widgets";
import WebusAfterSection from "@/widgets/app/page/webus/WebusAfterSection";
import WebusBackgroundSection from "@/widgets/app/page/webus/WebusBackgroundSection";
import WebusHowToUseSection from "@/widgets/app/page/webus/WebusHowToUseSection";
import WebusInfoSection from "@/widgets/app/page/webus/WebusInfoSection";
import WebusNotificationSection from "@/widgets/app/page/webus/WebusNotificationSection";
import { SsgoiTransition } from "@ssgoi/react";

export default function WebusPage() {
  return (
    <SsgoiTransition id="/app/pages/webus">
      <div className="max-[991px]:pt-16 flex pt-24 w-full flex-col">
        <AppPageTitle />
      </div>

      <div className="w-full flex-col">
        {/* 메인  */}
        <WebusInfoSection />
        {/* 백그라운드 */}
        <WebusBackgroundSection />
        {/* 사용 방법 */}
        <WebusHowToUseSection />

        {/* 탑승정보 알림 */}
        <WebusNotificationSection />
        {/* 이용률 */}
        <WebusAfterSection />
      </div>
    </SsgoiTransition>
  );
}
